import React from "react";
import PropTypes from "prop-types";

// styles
import {
    HistoryListStyled,
    HistoryListItemStyled,
    DateStyled,
    MessageStyled
} from "./styles.js";

const HistoryList = ({ items }) => {
    return (
        <HistoryListStyled>
            {items.map(item => {
                return <HistoryListItem key={item.id} item={item} />;
            })}
        </HistoryListStyled>
    );
};

const HistoryListItem = ({ item }) => {
    return (
        <HistoryListItemStyled>
            <DateStyled>{item.date}</DateStyled>
            <MessageStyled>{item.message}</MessageStyled>
        </HistoryListItemStyled>
    );
};

export default HistoryList;

// prop-types
HistoryList.propTypes = {
    items: PropTypes.array
};
HistoryListItem.propTypes = {
    item: PropTypes.object.isRequired
};
